import { gql } from "apollo-boost";

const GET_VENDOR_LIST = gql`
  query getVendorList($input: GetListInputV1) {
    getVendorList(input: $input) {
      data {
        count
        vendors {
          email {
            address
            verified
          }
          firstName
          lastName
          onHoliday
          address
          brandName
          isInactive
          createdAt
          city
          firstName
          isApproved
          lastName
          logo
          phoneNumber
          pinCode
          provinceCode
          _id
          roles {
            name
          }
          paypal {
            emailId
            payerId
          }
          stripe {
            accountId
          }
          shop
          storeConfig {
            wix {
              instanceId
            }
            wooCommerce {
              shop
            }
            magento {
              shop
            }
            prestaShop {
              shop
            }
          }
        }
      }
      status
      error
    }
  }
`;
const VERIFY_OTP = gql`
  query verifyOtp($input: VerifyOtp) {
    verifyOtp(input: $input) {
      data {
        token
      }
      status
      error
    }
  }
`;

const GET_SELLER_ASSOCIATION = gql`
  query getSellerAssociation($input: GetSellerAssociation!) {
    getSellerAssociation(input: $input) {
      status
      error
      data {
        _id
        shop
      }
    }
  }
`;

// A slim companion to GET_VENDOR_LIST for pages that only need to know which
// vendors are on holiday or inactive. The full document pulls ~25 fields -
// logos, store configs, payment accounts - which this seller fans out over 296
// vendors on every product list load. The shared document is left untouched.
const GET_VENDOR_LIST_STATUS = gql`
  query getVendorList($input: GetListInputV1) {
    getVendorList(input: $input) {
      data {
        count
        vendors {
          _id
          isInactive
          onHoliday
        }
      }
      status
      error
    }
  }
`;

export { GET_VENDOR_LIST, GET_VENDOR_LIST_STATUS, VERIFY_OTP, GET_SELLER_ASSOCIATION };
